import { postRawRequest } from '../../httpClient';
import type { ITranslateCollectionParams } from './translate-collection-request';

const ONE_HOUR_MS = 3_600_000;

export async function translateCollectionApi({
  collectionId,
  langs,
  limit,
  force,
}: ITranslateCollectionParams): Promise<Response> {
  const body: Record<string, unknown> = {};
  if (langs?.length) {
    body.langs = langs;
  }
  if (limit) {
    body.limit = limit;
  }
  if (force) {
    body.force = true;
  }

  return postRawRequest({
    path: `/sys/pipeline/${collectionId}/translate`,
    body,
    options: { timeout: ONE_HOUR_MS },
  });
}
